"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerConnection = void 0;
const codecs_1 = require("./codecs");
const helpers_1 = require("./helpers");
const stat_interpreter_1 = __importDefault(require("./stat-interpreter"));
// WebRTC defaults
var peerConnectionConfig = {
    //bundlePolicy: 'max-compat',
    //iceTransportPolicy: 'relay',
    iceServers: [
        {
            urls: "stun:stun.l.google.com:19302",
        },
        {
            urls: "turn:anywhere.mictap.com:3479",
            username: "franco",
            credential: "12345678",
        },
    ],
};
const STATS_INTERVAL_MS = 100;
// ----------------------
// Status updates events
// ------------------
function handleSignalingStateChange(pc, event) {
    console.log("[WebRTC] Signalling state changed -> " + pc.signalingState);
    if (pc.signalingState == "closed") {
        alert("Signalling state is closed, maybe restartICE");
    }
}
function handleIceConnectionStateChange(pc, event, onDisconnected) {
    switch (pc.iceConnectionState) {
        case "connected":
            // tell the handler we got connected?
            break;
        case "failed":
            console.error("Error with PC, maybe restartICE");
            // pc.restartIce();
            break;
        case "closed":
        case "disconnected":
            console.log("[WebRTC] Failed state PC STATE", pc.iceConnectionState);
            console.log("[WebRTC] We got disconnected", pc.iceConnectionState);
            onDisconnected(pc.iceConnectionState);
        default:
            console.log("I[WebRTC] CE connection state changed -> " + pc.iceConnectionState);
    }
}
// Adds ice candidate to PC
// This function should be set for the pc's onicecandidate event
// returns an error if add ice candidate fails
async function processIceSignalIceCandidate(pc, remoteCandidate) {
    let candidate = remoteCandidate.candidate;
    var iceCandidate = new RTCIceCandidate({
        sdpMid: candidate.sdpMid,
        sdpMLineIndex: candidate.sdpMLineIndex,
        candidate: candidate.candidate,
    });
    try {
        await pc.addIceCandidate(iceCandidate);
        return;
    }
    catch (_a) {
        return "Error adding ice candidate";
    }
}
// returns a valid offer given a PC and a target for SFU target can be null
async function createOffer(pc, sdpTransformer = null) {
    // old method to do this
    const offer = await pc.createOffer();
    if (sdpTransformer) {
        offer.sdp = sdpTransformer(offer.sdp, "offer");
    }
    await pc.setLocalDescription(offer);
    return {
        type: "",
        sdp: "",
        messageType: "offer",
        body: offer.sdp,
        tracks: [""],
    };
}
// returns a valid answer given a PC and a target for SFU target can be null
async function createAnswerPC(pc, sdpTransformer = null) {
    const answer = await pc.createAnswer();
    if (sdpTransformer) {
        answer.sdp = sdpTransformer(answer.sdp, "answer"); // it seems that by changing the answer this crashes the newer build of Pion/SFU
    }
    await pc.setLocalDescription(answer);
    return answer.sdp;
}
////////////////////////////////////////////////////////////////////
function handleRemoteTrackRemoved(evt) {
    (0, helpers_1.todo)("Remote track removed not implemented");
}
var Debug = false;
class PeerConnection {
    constructor(pcConfig, senderFn, newTrackFn, onDisconnectedFn, sdpTransformer) {
        this.dataChannel = null;
        this.dataChannelReady = false;
        this.shouldSendPacketLoss = 0;
        this.shouldSendNoAudio = 0;
        this.tracksRemainingToBeSet = 0;
        this.newTracks = [];
        this.RTCTracks = [];
        this.RTCSenders = {};
        this.pc = null;
        this.statsInterval = null;
        this.statInterpreter = new stat_interpreter_1.default();
        this.pcConfig = pcConfig;
        this.newPC();
        // current state of the Peer connection, this is to avoid collisions
        this.state = {
            connected: false,
            isSettingRemoteAnswerPending: false,
            makingOffer: false,
            polite: false,
        };
        this.sdpTransformer = sdpTransformer;
        this.sender = senderFn;
        this.newTrackHandler = newTrackFn;
        this.onDisconnected = onDisconnectedFn;
        this.lastPacketLossSentAt = null;
        this.latestVideoTrackId = "";
        this.lastNoAudioSentAt = Date.now();
    }
    newPC() {
        this.pc = new RTCPeerConnection(peerConnectionConfig);
        if (this.pcConfig.dataChannel) {
            const dataChannel = this.pc.createDataChannel(`DataChannel_${12345}`);
            this.setupDataChannel(dataChannel);
        }
        this.pc.onicecandidate = (e) => this.handleIceCandidateAndSend(e);
        this.pc.ontrack = (e) => this.newTrackInterceptor(e);
        this.pc.onsignalingstatechange = (e) => {
            if (this.pc == null) {
                return;
            }
            handleSignalingStateChange(this.pc, e);
        };
        this.pc.oniceconnectionstatechange = (e) => {
            if (this.pc == null) {
                return;
            }
            handleIceConnectionStateChange(this.pc, e, this.onDisconnected);
        };
        this.pc.onicegatheringstatechange = (e) => {
            if (this.pc == null) {
                return;
            }
            this.updateStats(this.pc);
        };
        this.pc.onnegotiationneeded = (e) => this.handleNegotiationNeeded();
        this.pc.ondatachannel = (e) => this.handleDataChannel(e);
        console.log("[WebRTC] 1. WebRTC Protocol successfully started");
        this.statsInterval = window.setInterval(() => {
            if (this.pc == null) {
                return;
            }
            this.updateStats(this.pc);
        }, STATS_INTERVAL_MS);
        // have at least a video and audio transceiver?
        if (this.pcConfig.receiveVideo) {
            this.pc.addTransceiver("video");
        }
        this.pc.addTransceiver("audio");
    }
    // -------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    // ----------------------WEB RTC STUFF ---------------------------------------
    // -------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    async handleNegotiationNeeded() {
        console.log("[WebRTC] ....Negotiation needed");
        // wait for all the tracks to be setup
        while (this.tracksRemainingToBeSet > 0) {
            //MAGIC NUMBER
            await (0, helpers_1.sleep)(100);
        }
        this.call();
    }
    // this is the "destructor" for the PC to be able to be shutdown gracefully
    Close() {
        if (this.pc != null) {
            this.pc.close();
            this.pc = null;
            if (this.statsInterval != null) {
                clearInterval(this.statsInterval);
            }
        }
    }
    // create an offer and emits it as a signal the actual signal should actually be a closure
    async call() {
        if (this.pc == null) {
            if (Debug)
                console.log("[WebRTC] PC is null on call");
            return;
        }
        (0, codecs_1.setDefaultCodecs)(this.pc);
        try {
            this.state.makingOffer = true;
            console.log("[WebRTC] 6. Calling peer...", this.pc.localDescription, this.pc.signalingState);
            let offer = await createOffer(this.pc, this.sdpTransformer);
            offer.tracks = this.newTracks.map((t) => t.id + "__" + t.label);
            this.newTracks = [];
            offer.type = "rtc--offer";
            offer.sdp = offer.body;
            this.emit(offer);
        }
        catch (err) {
            console.error("ERROR creating offer", err);
            (0, helpers_1.todo)("handleCreateOfferError", err);
        }
        finally {
            this.state.makingOffer = false;
        }
    }
    emit(data) {
        this.sender(data);
    }
    async handleRemoteDescriptionWithPC(msg) {
        if (this.pc == null) {
            console.log("[WebRTC] PC is null on handleRemoteDescriptionWithPC");
            return;
        }
        try {
            // check if the message received is an offer or not.
            const isOffer = msg.type == "rtc--offer";
            console.log("[WebRTC] 7. Handle remote " + msg.type);
            const readyForOffer = !this.state.makingOffer &&
                (this.pc.signalingState === "stable" ||
                    this.state.isSettingRemoteAnswerPending);
            const offerCollision = isOffer && !readyForOffer;
            const ignoreOffer = !this.state.polite && offerCollision;
            if (ignoreOffer) {
                console.log("[WebRTC] ignoring sdp", isOffer, readyForOffer, this.state.makingOffer, this.pc.signalingState, this.state.isSettingRemoteAnswerPending, this.state.polite);
                return;
            }
            console.log("[WebRTC] handle remote SDP", msg, isOffer);
            // This is to handle both peer 2 peer (SDP is in body)
            // and to handle SFU connection (SDP is in sdp)
            if (msg.sdp == null && msg.body != null) {
                msg.sdp = msg.body;
            }
            this.state.isSettingRemoteAnswerPending = !isOffer;
            const description = new RTCSessionDescription({
                sdp: msg.sdp,
                type: isOffer ? "offer" : "answer",
            });
            await this.pc.setRemoteDescription(description);
            this.state.isSettingRemoteAnswerPending = false;
            if (isOffer) {
                const answerSDP = await createAnswerPC(this.pc, this.sdpTransformer);
                const answer = {
                    sdp: answerSDP,
                    type: "rtc--answer",
                    tracks: this.newTracks.map((t) => t.id + "__" + t.label),
                };
                this.emit(answer);
                if (Debug)
                    console.log("[WebRTC] sending back answer");
            }
            this.state.connected = true;
            return true;
        }
        catch (err) {
            console.error(err);
            // if theres an error handling, maybe we need to recreate the pc?
            console.log("recreating pc");
            this.newPC();
            this.handleRemoteDescriptionWithPC(msg);
        }
    }
    setAudioCodec(codec) {
        if (this.pc)
            (0, codecs_1.setAudioCodec)(this.pc, codec);
    }
    handleIceCandidateAndSend(event) {
        const candidate = (0, helpers_1.handleIceCandidate)(event);
        this.emit(candidate);
    }
    SetTracks(RTCTracks) {
        if (this.pc == null) {
            window.setTimeout(() => {
                this.SetTracks(RTCTracks);
            }, 300);
            return;
        }
        this.RTCTracks = RTCTracks;
        if (this.RTCTracks == null) {
            if (Debug)
                console.log("[WebRTC] tracks were not passed, they are null");
            return;
        }
        RTCTracks.forEach(this.processTracks.bind(this));
    }
    async processTracks(rtcTrack) {
        if (this.pc == null) {
            console.log("[WebRTC] PC is null on filterTracks");
            return;
        }
        const oldSender = this.RTCSenders[rtcTrack.label];
        try {
            if (oldSender && oldSender.sender && rtcTrack.track == null) {
                // theres no longer a track just remove it
                this.pc.removeTrack(oldSender.sender);
                this.RTCSenders[rtcTrack.label] = null;
                if (Debug)
                    console.log("[WebRTC] track", rtcTrack.label);
            }
            if (rtcTrack.track == null) {
                if (Debug)
                    console.log("[WebRTC] track to add null", rtcTrack.label, oldSender);
                return;
            }
            // if it is the same track, just skip it
            if (oldSender && oldSender.id == rtcTrack.track.id) {
                if (Debug)
                    console.log("[WebRTC] seems you're trying to add an already added track, skip this");
                return;
            }
            this.tracksRemainingToBeSet++;
            if (oldSender && oldSender.id != rtcTrack.track.id) {
                const newSender = await (0, helpers_1.replaceTrack)(this.pc, oldSender.sender, rtcTrack.track, rtcTrack.stream);
                this.RTCSenders[rtcTrack.label] = {
                    sender: newSender,
                    id: rtcTrack.track.id,
                };
                if (Debug)
                    console.log("[WebRTC] We replaced a track", rtcTrack, newSender);
                this.newTracks.push(rtcTrack);
                this.tracksRemainingToBeSet--;
                return;
            }
            if (Debug)
                console.log("[WebRTC] We added a new track", rtcTrack);
            const newSender = this.pc.addTrack(rtcTrack.track, rtcTrack.stream);
            this.RTCSenders[rtcTrack.label] = {
                sender: newSender,
                id: rtcTrack.track.id,
            };
            this.newTracks.push(rtcTrack);
            this.tracksRemainingToBeSet--;
        }
        catch (e) {
            console.error("[WebRTC] it seems we couldn't add the track", rtcTrack, "reason", e);
        }
    }
    HandleRemoteDescription(sdp) {
        this.handleRemoteDescriptionWithPC(sdp);
    }
    async ProcessIceSignalIceCandidate(msg) {
        if (this.pc == null) {
            if (Debug)
                console.log("[WebRTC] PC is null on processIceSignalIceCandidate");
            return;
        }
        const err = await processIceSignalIceCandidate(this.pc, msg);
        if (err != null) {
            if (Debug)
                console.log("[WebRTC] adding candidate" + err);
            return;
        }
        if (Debug)
            console.log("[WebRTC] ...Added candidate successfully");
    }
    changeAudioBitrate(bitrate) {
        const audioTracks = this.RTCTracks.filter((track) => typeof track !== "undefined" &&
            track.track !== null &&
            track.track.kind === "audio");
        audioTracks.forEach((track) => {
            // get the current parameters first
            const rtcSender = this.RTCSenders[track.label];
            if (!rtcSender)
                return;
            if (!rtcSender.sender)
                return;
            const params = rtcSender.sender.getParameters();
            if (!params)
                return;
            params.encodings.forEach((p) => {
                p.maxBitrate = bitrate;
                p.networkPriority = "high";
                p.priority = "high";
            });
            console.log("[WebRTC] Setting audio parameters for track", track.id, params, bitrate);
            try {
                rtcSender.sender.setParameters(params);
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    changeVideoBitrate(bitrate, scaleFactor = 1) {
        const videoTracks = this.RTCTracks.filter((track) => typeof track !== "undefined" &&
            track.track !== null &&
            track.track.kind === "video");
        videoTracks.forEach((track) => {
            var _a;
            const rtcSender = this.RTCSenders[track.label];
            if (!rtcSender)
                return;
            if (!rtcSender.sender)
                return;
            const params = rtcSender.sender.getParameters();
            if (!params)
                return;
            params.encodings.forEach((p) => {
                p.maxBitrate = bitrate * 1000;
                p.scaleResolutionDownBy = scaleFactor;
                p.maxFramerate = 100; // not sure if this applied
                p.networkPriority = "high";
                p.priority = "high";
            });
            console.log("[WebRTC] Setting parameters for track", track.id, params);
            (_a = rtcSender.sender) === null || _a === void 0 ? void 0 : _a.setParameters(params);
        });
    }
    // -----------------
    // Stats
    // -----------------
    async updateStats(pc) {
        if (pc == null) {
            console.log("[WebRTC] PC is null on updateStats");
            return;
        }
        try {
            const stats = await pc.getStats();
            this.checkIfShouldSendPLI(stats);
            this.statInterpreter.updateStats(stats);
        }
        catch (error) {
            console.error("Error retrieving stream statistics:", error);
        }
    }
    getStats() {
        return this.statInterpreter.getStatsReport();
    }
    checkIfShouldSendPLI(stats) {
        const maxIntraPLIDuration = 1000;
        // this test is a bit too fast, we should maybe make less sensitive
        let frozen_streams = [];
        stats.forEach((report) => {
            // Access the statistics for the video track
            // Also we check that the track is the latest
            // This is technically a Mirror requirement as the host can only have one video feed
            // If the host could have mre than one video this wouldn't really work as well
            if (report.type === "inbound-rtp" && report.kind == "video") {
                // Checking by latestVideoTrackId doesn't seem to be working
                // if (report.trackIdentifier == this.latestVideoTrackId){
                // }
                // Extract relevant metrics
                const frameRate = report.framesPerSecond;
                // TODO: implement an exponential back off for packet loss sending?
                // Check for frozen stream or degraded frame rate
                if (frameRate === 0 || frameRate == null) {
                    // console.log('Video stream is frozen - Should send PLI back?.', report.trackIdentifier, this.latestVideoTrackId);
                    if (this.lastPacketLossSentAt != null &&
                        Date.now() - this.lastPacketLossSentAt < maxIntraPLIDuration) {
                        // skip
                        // console.log('Already sent a PLI, just wait a bit', frameRate);
                        return;
                    }
                    else {
                        this.shouldSendPacketLoss++;
                        frozen_streams.push(report.trackIdentifier);
                    }
                }
                else if (frameRate) {
                    // If at least one of the videos is not frozen then its fine don't send PLI
                    this.shouldSendPacketLoss = -50;
                    if (frameRate < 25) {
                        // console.log("Video frame rate is degraded.", frameRate);
                    }
                }
            }
            if (report.type == "outbound-rtp" && report.kind == "audio") {
                if (report.bytesSent == 0) {
                    this.shouldSendNoAudio += 1;
                }
                else {
                    this.shouldSendNoAudio = -50;
                }
            }
        });
        if (this.shouldSendNoAudio > 50 &&
            Date.now() - this.lastNoAudioSentAt > maxIntraPLIDuration) {
            this.lastNoAudioSentAt = Date.now();
            console.log("No audio being sent, something's up");
            this.shouldSendNoAudio = 0;
            const noAudio = {
                type: "rtc--no-audio",
            };
            this.emit(noAudio);
        }
        if (this.shouldSendPacketLoss > 2) {
            console.log("packet loss detected", this.latestVideoTrackId, frozen_streams);
            this.lastPacketLossSentAt = Date.now();
            const packetLoss = {
                type: "rtc--pli-detected",
                kind: "video",
                stream_id: frozen_streams[0],
            };
            this.shouldSendPacketLoss = 0;
            this.emit(packetLoss);
        }
    }
    newTrackInterceptor(e) {
        console.log("NEW TRACK", e);
        if (e.track.kind == "video") {
            this.latestVideoTrackId = e.track.id;
        }
        this.newTrackHandler(e);
        e.streams.forEach((stream) => {
            // refactor this to be instead for MediaStream.onremovetrack
            stream.onremovetrack = (e) => handleRemoteTrackRemoved(e);
        });
    }
    // Data Channel related messages
    sendMessageDataChannel(message) {
        var _a;
        if (!this.dataChannelReady)
            return;
        message = JSON.stringify(message);
        (_a = this.dataChannel) === null || _a === void 0 ? void 0 : _a.send(message);
    }
    setupDataChannel(dataChannel) {
        this.dataChannel = dataChannel;
        this.dataChannel.onopen = () => this.handleDataChannelOpen();
        this.dataChannel.onclose = () => this.handleDataChannelClose();
        this.dataChannel.onmessage = (e) => this.handleDataChannelMessage(e);
    }
    handleDataChannel(event) {
        this.setupDataChannel(event.channel);
    }
    handleDataChannelOpen() {
        if (Debug)
            console.log("Data channel set up successfully");
        this.dataChannelReady = true;
        this.sendMessageDataChannel("some TEST message");
    }
    handleDataChannelClose() {
        this.dataChannelReady = false;
    }
    handleDataChannelMessage(event) {
        const message = JSON.parse(event.data);
        if (message.type === "latency") {
            this.emit(message);
        }
    }
}
exports.PeerConnection = PeerConnection;
